<template>
  <div style="min-width: 15em;">
    <canvas ref="progressCanvas" width="200" height="200"/>
    <div class="circle">
      <div style="height: 100%; padding-top: 2.8em">
        <b style="font-size:1.5em">{{ progress }}</b>
        <b style="font-size:1.2em">%</b><br>
        <div style="margin-top:-.4em; margin-left:-.2em">
          <span style="font-size:.7em; color:rgba(0,0,0,0.55)">{{ value }}/{{ total }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      default: 0,
    },
    value: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },

  },
  mounted() {
    this.drawProgress();
  },
  data() {
    return {
      progressLocal: 0
    }
  },
  methods: {
    drawProgress() {
      if (this.$refs.progressCanvas != null) {
        const canvas = this.$refs.progressCanvas;
        const ctx = canvas.getContext('2d');
        const centerX = canvas.width / 2;
        const centerY = canvas.height / 2;
        const radius = 60;
        const lineWidth = 10;
        const progress = this.progressLocal / 100;

        // Clear canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Draw background circle
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = '#008F641A';
        ctx.stroke();

        // Draw progress arc
        ctx.beginPath();
        ctx.arc(
            centerX,
            centerY,
            radius,
            -0.5 * Math.PI,
            -0.5 * Math.PI + 2 * Math.PI * progress
        );
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = '#008F64';
        ctx.stroke();
      }
      if (this.progress > this.progressLocal) this.progressLocal++
    },
  },
  watch: {
    progress() {
      this.progressLocal++
    },
    progressLocal() {
      setTimeout(() => {
        this.drawProgress()
      }, 10);
    }
  },
};
</script>

<style scoped lang="scss">
.circle {
  position: relative;
  top: 5px;
  text-align: center;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background-color: #ffffff;
  margin-top: -164px;
  margin-left: auto;
  margin-right: auto;
}
</style>
